import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./asset/css/libraries/bootstrap.min.css";
import "./asset/css/style.css";
import "./asset/js/custom";
import "../node_modules/select2/dist/css/select2.min.css";
import "../node_modules/select2/dist/js/select2.min";
import { init as initApm } from "@elastic/apm-rum";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { ZeroPrefix } from "./CommonMethods/CommonMethods";

// const apm = () => {
//   initApm({
//     serviceName: "Neon_Portal",
//     serverUrl: "https://kibana.bajajfinservsecurities.in/apm",
//     serviceVersion: "",
//     environment: "uat",
//   });
// };
// apm();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  </>
);

String.prototype.reverseDob = function () {
  let enteredArray = this.split("-").reverse().join("-");
  return enteredArray;
};
String.prototype.getMinor = function () {
  let enteredDate = new Date(this);
  // return Math.abs(ageDate.getUTCFullYear() - 1970);
  let enteredTime = enteredDate.getTime();
  let CurrentDate = new Date();
  let MinorDateSet = CurrentDate.setFullYear(CurrentDate.getFullYear() - 18);
  let MinorFormat = new Date(MinorDateSet);
  let CompareDate = MinorFormat - enteredTime;
  if (Math.sign(CompareDate) === -1) {
    return false;
  } else {
    return true;
  }
};

// partner date
String.prototype.isValidDate = function () {
  // An invalid date object returns NaN for getTime() and NaN is the only
  // object not strictly equal to itself.
  let currentDate = new Date(this);
  if (currentDate == "Invalid Date" || this.length !== 10) {
      return false
  }
  let [year, month, day] = this.split("-");

  console.log(currentDate, "currentDate");

  console.log(currentDate.getDay(), "currentDate.getDay()");

  console.log(currentDate, "currentDate");

  console.log(currentDate.getDate(), "currentDate");

  let [matchday, matchmonth, matchyear] = [currentDate.getDate(), currentDate.getMonth() + 1, currentDate.getFullYear()]




  // day = ZeroPrefix(day)
  // month = ZeroPrefix(month)

  matchday = ZeroPrefix(matchday)
  matchmonth = ZeroPrefix(matchmonth)


  console.log(day == matchday && matchmonth == month, "vvvvvvvvvvvvv")
  return day == matchday && matchmonth == month

};

String.prototype.underFutureDate = function () {
  let EnteredDate = new Date(this);

  if (
    EnteredDate === NaN ||
    this.length !== 10 ||
    EnteredDate == "Invalid Date"
  ) {
    return false;
  }
  let CurrentDate = new Date();
  let MajorDateSet = CurrentDate.setFullYear(CurrentDate.getFullYear() - 90);
  let MajorFormat = new Date(MajorDateSet);

  let MajorDateTime = EnteredDate.getTime() - MajorFormat.getTime();
  let FutherDate = Date.now() - EnteredDate.getTime();
  if (Math.sign(FutherDate) === -1 || Math.sign(MajorDateTime) === -1) {
    return false;
  } else {
    return true;
  }
};
String.prototype.maxAgeVal = function () {
  let enteredDate = new Date(this);

  // return Math.abs(ageDate.getUTCFullYear() - 1970);
  let enteredTime = enteredDate.getTime();
  let CurrentDate = new Date();
  let MinorDateSet = CurrentDate.setFullYear(CurrentDate.getFullYear() - 90);
  let MinorFormat = new Date(MinorDateSet);
  let CompareDate = MinorFormat - enteredTime;

  if (Math.sign(CompareDate) === -1) {
    return false;
  } else {
    return true;
  }
};
// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
